import {
  DynamicVariable,
  mapResponsivePropToCSSVars,
} from "@faire/deprecated-retailer-visitor-shared/lib/tailwindUtils";

export const MOBILE_BANNER_HEIGHT = 324;
export const TABLET_BANNER_HEIGHT = 450;
export const DESKTOP_BANNER_HEIGHT = 604;
export const XLARGE_BANNER_HEIGHT = 655;
export const XLARGE_BANNER_WIDTH = 541;

const bannerMinHeightVar: DynamicVariable<"--f-banner-min-height"> = {
  variable: "--f-banner-min-height",
  className: "min-h-(--f-banner-min-height)",
};

const bannerMinHeightTabletVar: DynamicVariable<"--f-banner-min-height-md"> = {
  variable: "--f-banner-min-height-md",
  className: "md:min-h-(--f-banner-min-height-md)",
};

const bannerMinHeightDesktopVar: DynamicVariable<"--f-banner-min-height-lg"> = {
  variable: "--f-banner-min-height-lg",
  className: "lg:min-h-(--f-banner-min-height-lg)",
};

const bannerMinHeightXLargeVar: DynamicVariable<"--f-banner-min-height-xl"> = {
  variable: "--f-banner-min-height-xl",
  className: "xl:min-h-(--f-banner-min-height-xl)",
};

export const bannerMinHeightVars = mapResponsivePropToCSSVars(
  {
    mobileAndAbove: "auto",
    tabletAndAbove: `${TABLET_BANNER_HEIGHT}px`,
    desktopAndAbove: `${DESKTOP_BANNER_HEIGHT}px`,
    xLargeAndAbove: `${XLARGE_BANNER_HEIGHT}px`,
  },
  {
    mobileAndAbove: bannerMinHeightVar,
    tabletAndAbove: bannerMinHeightTabletVar,
    desktopAndAbove: bannerMinHeightDesktopVar,
    xLargeAndAbove: bannerMinHeightXLargeVar,
  }
);

const imageWrapperWidthVar: DynamicVariable<"--f-image-wrapper-width"> = {
  variable: "--f-image-wrapper-width",
  className: "max-w-(--f-image-wrapper-width)",
};

const imageWrapperWidthXLargeVar: DynamicVariable<"--f-image-wrapper-width-xl"> =
  {
    variable: "--f-image-wrapper-width-xl",
    className: "xl:max-w-(--f-image-wrapper-width-xl)",
  };

export const imageWrapperWidthVars = mapResponsivePropToCSSVars(
  {
    mobileAndAbove: "auto",
    xLargeAndAbove: `${XLARGE_BANNER_WIDTH}px`,
  },
  {
    mobileAndAbove: imageWrapperWidthVar,
    xLargeAndAbove: imageWrapperWidthXLargeVar,
  }
);

const imageWrapperHeightVar: DynamicVariable<"--f-image-wrapper-height"> = {
  variable: "--f-image-wrapper-height",
  className: "h-(--f-image-wrapper-height)",
};

const imageWrapperHeightTabletVar: DynamicVariable<"--f-image-wrapper-height-md"> =
  {
    variable: "--f-image-wrapper-height-md",
    className: "md:h-(--f-image-wrapper-height-md)",
  };

export const imageWrapperHeightVars = mapResponsivePropToCSSVars(
  {
    mobileAndAbove: `${MOBILE_BANNER_HEIGHT}px`,
    tabletAndAbove: "auto",
  },
  {
    mobileAndAbove: imageWrapperHeightVar,
    tabletAndAbove: imageWrapperHeightTabletVar,
  }
);
